<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Pessoas</b>
						</h3>
					</div>
					<div class="box-body">

						<transition v-if="showModalTelefone" name="modal">
							<div class="modal-mask">
								<div class="modal-container">
									<div class="modal-header">
										<h3>Telefones</h3>
									</div>
									<div class="modal-body">
										<div class="row">
											<div class="col-sm-4">
												<div :class="{'form-group': true}">
												<input
													v-mask="['(##) #####-####', '(##) ####-####']"
													class="form-control"
													name="telefone"
													type="text"
													v-model="input.telefone"
													placeholder="Telefone"
													ref="telefone"
												>
												</div>
											</div>

											<div class="col-sm-6">
												<div :class="{'form-group': true}">
												<input
													class="form-control"
													name="contato"
													type="text"
													v-model="input.contato"
													placeholder="Contato"
												>
												</div>
											</div>

											<div class="col-sm-2">
												<span class="input-group-btn">
													<button @click="adicionaTelefone()" style="width: 100%" type="button" id="bt-add-telefone" class="btn btn-warning btn-flat">Adicionar</button>
												</span>
											</div>
										</div>
										<div class="row" style="margin-top:15px">
											<div class="col-sm-12 table-responsive">
												<table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
													<thead>
													<tr role="row">
														<th style="width: 5%">ID</th>
														<th style="width: 25%">Telefone</th>
														<th style="width: 40%">Contato</th>
														<th style="width: 20%">Data do Cadastro</th>
														<th style="width: 10%" >Ação</th>
													</tr>
													</thead>
													<tbody>
													<tr class="even" role="row" v-for="item in telefones" :key="item.id">
														<td>{{ item.id }}</td>
														<td>{{ item.telefone }}</td>
														<td>{{ item.contato }}</td>
														<td>{{ item.created_at | dataFormatada }}</td>
														<td>
															<button @click="deletaTelefone(item.id)" class="btn btn-danger btn-sm" tag="button" title="Remover">
																<i class="fa fa-fw fa-close"></i>
															</button>
														</td>
													</tr>
													</tbody>
												</table>

											</div>
										</div>
									</div>
									<div class="modal-footer">
										<div class="text-right" style="float:right">
											<button class="btn btn-default" @click="()=> {showModalTelefone = false; input.pessoa_id = null}">
												<i class="fa fa-close"></i> Fechar
											</button>
										</div>
									</div>
								</div>
							</div>
						</transition>

						<div class="row">
							<div class="col-md-12">
								<input style="width: 100%" class="form-control" placeholder="Busca: Entre com o nome da pessoa" name="filtro_pesquisa" ref="filtro_pesquisa" type="text" v-model="filtros.pesquisa" @keyup.enter="getDataTable">
							</div>
						</div>
						<div class="row" style="margin-top:15px">
							<div class="col-sm-12 table-responsive">
								<table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
									<thead>
									<tr role="row">
										<th style="width: 8%">ID</th>
										<th style="width: 28%">Nome/Razão</th>
										<th style="width: 16%">CPF/CNPJ</th>
										<th style="width: 10%">Telefone 1</th>
										<th style="width: 10%">Telefone 2</th>
										<th style="width: 8%">Situação</th>
										<th style="width: 10%" >Ação</th>
									</tr>
									</thead>
									<tbody>
									<tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
										<td>{{ item.id }}</td>
										<td>{{ item.nome_razao }}</td>
										<td>{{ item.cpf_cnpj }}</td>
										<td>{{ item.telefone1 }}</td>
										<td>{{ item.telefone2 }}</td>
										<td>ATIVO</td>
										<td>
											<router-link class="btn btn-warning btn-sm" tag="button" :to="`/administracao/pessoas/atualizacao/${item.id}`" title="Atualizar">
												<i class="fa fa-fw fa-edit"></i>
											</router-link>
											<button @click="getTelefones(item.id)" class="btn btn-info btn-sm" title="Telefones">
												<i class="fa fa-fw fa-phone"></i>
											</button>
										</td>
									</tr>
									</tbody>
								</table>
								<div class="row">
									<div class='col-sm-5'>
										Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.
									</div>
									<div class='col-sm-7' style="text-align:right">
										<laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
											<span slot="prev-nav">&lt; Anterior</span>
											<span slot="next-nav">Próximo &gt;</span>
										</laravue-pagination>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- /.box-body -->
				</div>
				<!-- /.box -->
			</div>
			<!-- /.col-md-12 -->
		</div>
		<!-- /.row -->
	</section>
</template>
<script>
	import axios from 'axios' // Cliente para requisição http
	import {mask} from 'vue-the-mask'
	export default {
		directives: {mask},
		data: () => ({
			showModalTelefone: false,
			telefones: [],
			input: {
				telefone: '',
				contato: '',
				pessoa_id: null
			},
			filtros: {
				pesquisa: '',
			},
			apiData: {
				data: [],
			},
		}),
		mounted () {
			this.getDataTable();
			this.$nextTick(() => { this.$refs.filtro_pesquisa.focus() });
		},

		methods: {
			adicionaTelefone() {
				axios
				.post(
					`${this.$store.state.serverURI}/api/pessoa/adicionaTelefone`,
					this.input,
					this.$store.getters.getHeaderAuth
				)
				.then(response => {
					this.getTelefones(this.input.pessoa_id);
					this.input.telefone = '';
					this.input.contato = '';
				})
				.catch(error => {
					console.log(error);
				});
			},
			deletaTelefone(telefoneId) {
				let config = this.$store.getters.getHeaderAuth;
				axios
				.get(
					`${this.$store.state.serverURI}/api/pessoa/deletaTelefone/${telefoneId}`,
					config
				)
				.then(response => {
					this.getTelefones(this.input.pessoa_id);
				})
				.catch(error => {
					console.log(error);
				});
			},
			getTelefones(pessoaId) {
				this.showModalTelefone = true;
				// this.refs.telefone.focus();
				this.input.pessoa_id = pessoaId;
				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;
				axios.get(`${this.$store.state.serverURI}/api/pessoa/getTelefones/${pessoaId}`, config).then(response => {
					this.telefones = response.data;

				}).catch((error) => {
					this.$store.commit('throwException', error);
				});
			},
			getDataTable (page) {
				if (typeof page === 'undefined') {
					page = 1;
				}
				this.filtros.page = page;
				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;
				axios.get(`${this.$store.state.serverURI}/api/pessoa/getAllPaginate`, config)
					.then(response => {
						this.apiData = response.data;
					}).catch((error) => { this.$store.commit('throwException', error); });
			},

		},
		watch: {
			page: function (val) {
				this.getDataTable();
			}
		},

		components: {

		}

	}
</script>
<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
	}

	.modal-container {
		width: 50%;
		margin: 40px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		margin: 10px 0;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 500px;
		overflow-y: auto;
	}
	section {
		font-size: 14px !important;
	}
</style>




// WEBPACK FOOTER //
// index.vue?177663cb